import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  leaves: [], // Initial leaves array
};

const requestLeaveSlice = createSlice({
  name: 'leaves',
  initialState,
  reducers: {
    setRequestLeaves: (state, action) => {
      state.leaves = action.payload;
    },
    addRequestLeave: (state, action) => {
      state.leaves.push(action.payload);
    },
    setStatus: (state, action) => {
      const leaveIndex = state.leaves.findIndex((leave) => leave.id === action.payload.id);
      if (leaveIndex !== -1) {
        state.leaves[leaveIndex].status = action.payload.status;
      }
    },
    updateRequestLeave: (state, action) => {
      const updatedLeave = action.payload;
      state.leaves = state.leaves.map((leave) =>
        leave.id === updatedLeave.id ? updatedLeave : leave
      );
    },
    deleteRequestLeave: (state, action) => {
      const leaveIndex = state.leaves.findIndex((leave) => leave.id === action.payload);
      if (leaveIndex !== -1) {
        state.leaves.splice(leaveIndex, 1);
      }
    },
  },
});

export const { setRequestLeaves, addRequestLeave, setStatus, updateRequestLeave, deleteRequestLeave } = requestLeaveSlice.actions;

export default requestLeaveSlice.reducer;

